const mapOptions = (data = [], filterStatus = "Active") => {
  if (!Array.isArray(data)) return [];

  return data
    .map((item) => {
      const label =
        item.label ||
        item.name ||
        item.empName ||
        item.employeeName ||
        item.documentType ||
        item.roleName ||
        item.roleType ||
        item.roleName ||
        // item.roleFamily ||
        item.organizationDetail;
      const value =
        item.value ||
        item.managerId ||
        item.reportingManagerId ||
        item.empId ||
        item.documentId ||
        item.roleName ||
        item.roleType ||
        item.roleType ||
        // item.roleFamily||
        item.organizationCode;

      return label && value ? { label, value } : null; // Ensure valid mapping
    })
    .filter(Boolean); // Remove null values
};

export default mapOptions;
